import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { type SelectFilterOption } from '../../select-filter';

const itemStyles = xcss({
	cursor: 'default',
	borderLeft: `${token('border.width.selected')} solid`,
	borderColor: 'color.border.inverse',
	':hover': {
		borderColor: 'color.border.selected',
		backgroundColor: 'color.background.neutral.subtle.hovered',
	},
});

const insideItemStyles = xcss({
	marginLeft: 'space.negative.025',
});

const itemHoveredStyles = xcss({
	borderColor: 'color.border.selected',
	backgroundColor: 'color.background.neutral.subtle.hovered',
});

const itemSelectedStyles = xcss({
	borderColor: 'color.border.selected',
	backgroundColor: 'color.background.selected',
});

type SelectItemProps = {
	hovered?: boolean;
	onClick: () => void;
	option: SelectFilterOption;
};

const DateOption = ({ option, hovered, onClick }: SelectItemProps): React.JSX.Element => (
	// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
	<Box
		xcss={[itemStyles, option.isSelected && itemSelectedStyles, hovered && itemHoveredStyles]}
		key={option.label}
		onClick={onClick}
		paddingInline="space.150"
		paddingBlock="space.075"
	>
		<Box xcss={insideItemStyles}>{option.label}</Box>
	</Box>
);

export default DateOption;
